import View from '@/base/tables/view';

class AccessGroup extends View {

    static table = 'access_group';

}

export default AccessGroup;
